import AutoDeliveryDcxOnHoldInfoBox from '@/views/AutoDeliveryDcx/AutoDeliveryDcxOnHold/AutoDeliveryDcxOnHoldInfoBox';

import AutoDeliveryDcxDetailsDesktop from '../components/AutoDeliveryDcxDetailsDesktop';
import useAutoDeliveryDcxDetails from '../hooks/useAutoDeliveryDcxDetails';

const StatusOnHoldDesktop = () => {
    const {
        autoDelivery: {statusUpdateReason},
    } = useAutoDeliveryDcxDetails();

    return (
        <AutoDeliveryDcxDetailsDesktop
            status='onHold'
            extraSection={
                <AutoDeliveryDcxOnHoldInfoBox className='mt-4 bg-romance' statusUpdateReason={statusUpdateReason} />
            }
        />
    );
};

export default StatusOnHoldDesktop;
